import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import createDecorator from 'final-form-focus';
import Styles from "../Styles.js";
import { Error } from "../parts/error";
import { Affiliations } from "../parts/affiliations.js";
import { DataClassifications } from "../parts/dataClassifications.js";
import { Billing } from "../parts/billing.js";
import { Configuration } from "../parts/configuration.js";
import { Windows } from "../parts/windows.js";
import { CentOS } from "../parts/centos.js";
import { getTags, getComplianceFlags, getCores, getMemory } from "../util/config";
import { requestResource } from "../actions/resource";
import { GlobalContext } from '../global-context';
import AddMember from '../parts/addmember';
import { ERRORSTYLE, SCHEMAVERSION } from "../util/constants";

const required = value => (value ? undefined : "Required");
const requiredFields = ["affiliation", "title", "description", "compliance", "FDM", "billing_contact", "base_configuration", "vmos"];

const Condition = ({ when, is, children }) => (
  <Field name={when} subscription={{ value: true }}>
    {({ input: { value } }) => (value === is ? children : null)}
  </Field>
);

export default class IvyVMContainer extends Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);
    this.state = {
        requiredFieldsError: "",
        members: [],
        members_full: []
    };

    this.validateMember = this.validateMember.bind(this);
    this.removeMember = this.removeMember.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
  }

  checkRequiredFields = (values) => {
    requiredFields.forEach(field => {
      if (values[field] === undefined) {
        this.setState({
          requiredFieldsError: 'Please Fill Required Fields'
        });
        return;
      }
      else {
        this.setState({
          requiredFieldsError: ""
        });
      }
    })
  }

  onSubmit = async (values) => {
    const { navigate } = this.props;
    const { updatePerson } = this.context;
    const { members } = this.state;
    let project = {
      title: values.title,
      platform: "Ivy",
      schema_version: SCHEMAVERSION,
      description: values.description,
      members: members || [],
      flags: [],
      approval_required: true,
      tags: getTags(values)
    }

    let cflags = getComplianceFlags(values);
    if (cflags) {
      project.flags = cflags;
    }

    let ivyvm = {
      name: "IvyVM",
      tags: []
    }
    ivyvm.tags.push({
        name: "OperatingSystem",
        value: values["vmos"]
    });
    ivyvm.tags.push(getCores(values));
    ivyvm.tags.push(getMemory(values));
    ivyvm.tags.push({
      "name": "SoftwareLoad",
      "value": values.software ? values.software.join() : ""
    });

    await fetch(`/api/project`, {
			credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(project)
		})
    .then(res => res.json())
    .then(projectId => {

      const ics = {
          "name": "ICS",
          "tags": [
              {
                  "name": "SizeInTB",
                  "value": "1"
              }
          ]
      };

      Promise.all([
        requestResource(projectId, ivyvm),
        requestResource(projectId, ics)
      ]).then(function() {
        updatePerson();
        navigate(`project/${projectId}`);
      });
    })
    .catch((error) => {
      // To Do: UI error
		});
  };

  validateMember = async (value) => {
    let member_error = undefined;
    let add = undefined;
    const { members, members_full } = this.state;
    const { person } = this.context;
    let res = await fetch(`/api/person/${value}`).catch((error) => {
      console.log("ERROR in member lookup:", error);
    });
    if (!res || res.ok === false) {
      member_error = "User not found";
    } else {
      add = await res.json();
    }
    if (! member_error) {
      if ( add.id === person.id ) {
        member_error = "Owner is already a member"
      } else if ( members.includes(add.id)) {
        member_error = "Duplicate member"
      } else {
        members.push(add.id);
        members_full.push(add);
        this.setState({members, members_full})
      }
    }
    return member_error;
  }

  removeMember = (member) => {
    const { members, members_full } = this.state;
    const mindex = members.indexOf(member);
    members.splice(mindex, 1);
    members_full.splice(mindex, 1);
    this.setState({members, members_full});
  }

  render() {
    const { person, config } = this.context;
    const { members_full } = this.state;
    let memberlist = <h3>(No project members added)</h3>;
    if (members_full && members_full.length > 0) {
      memberlist = <div>
        <h3>Project Members</h3>
        <table className="project-tags">
          <tbody>
            <tr key="headings">
                <td className="headings-row">Name</td>
                <td className="headings-row">EPPN</td>
            </tr>
            {members_full.map((member, idx) =>
                <tr key={idx}>
                    <td>{member.display_name}</td>
                    <td>{member.id}</td>
                    <td>
                      <button
                        type="button"
                        onClick={() => this.removeMember(member.id)}
                      >
                        Remove
                      </button>
                    </td>
                </tr>
            )}
          </tbody>
        </table>
      </div>
    }
    const focusOnErrors = createDecorator()
    return (
      <div style={{padding: "50px"}}>
        <Styles>
          <h1>Request New Ivy VM</h1>
          <div>
            <AddMember
              add={this.validateMember}
            >
              <h2>Member Information</h2>
              <h3>Principal Investigator: {person.display_name}</h3>
              {memberlist}
              <label>Add a Project Member</label>
            </AddMember>
            <Form
              onSubmit={this.onSubmit}
              validate={values => {
                const errors = {}
                if (!values.TCP && values.compliance) {
                  let require_tcp = false
                  values.compliance.forEach(fname => {
                    if (fname === "Other") {
                      fname = "HSD"
                    }
                    const sidx = config.sensitivity_flags.indexOf(fname)
                    if (config.default_member_required_flags.length > sidx) {
                      if (config.default_member_required_flags[sidx].includes("TCP-Listed")) {
                        require_tcp = true
                      }
                    }
                  })
                  if (require_tcp) {
                    errors.TCP = "Required"
                  }
                }
                return errors
              }}
              decorators={[ focusOnErrors ]}
              render={({
                handleSubmit,
                reset,
                submitting,
                pristine,
                values,
                form: {
                  mutators: { push, pop }
                }}) => (
                <form onSubmit={handleSubmit}>
                  <h2>Project Information</h2>
                  <Affiliations validation={required}/>

                  <Field name="title" validate={required}>
                    {({ input, meta }) => (
                      <div>
                        <label>
                          <h3>Project Title*</h3>
                        </label>
                        <input {...input} type="text" placeholder="Project Title" />
                        {meta.error && meta.touched && <span style={ERRORSTYLE}>{meta.error}</span>}
                      </div>
                    )}
                  </Field>
                  <label>
                    <h3>Description*</h3>
                    <Error name="description" />
                    <Field name="description" component="textarea" validate={required} style={{width: "90%", height: "100px"}} />
                  </label>

                  <DataClassifications validation={required} classes={config.sensitivity_flags.map((flag) => { return {label: flag} }) }/>

                  <Field name="TCP">
                    {({ input, meta }) => (
                      <div>
                        <label>
                          <h3>Technology Control Plan (TCP) Number</h3>
                        </label>
                        <input {...input} type="text" />
                        {meta.error && meta.touched && <span>{meta.error}</span>}
                      </div>
                    )}
                  </Field>

                  <Billing values={values} />

                  <h2>Virtual Machine</h2>
                  <Configuration validation={required} />

                  <Condition when="vmos" is="Windows">
                    <h3>Pre-Installed Software for Windows</h3>
                    <Windows/>
                  </Condition>
                  <Condition when="vmos" is="CentOS">
                    <h3>Pre-Installed Software for CentOS</h3>
                    <CentOS/>
                  </Condition>

                  <div className="buttons">
                    {this.state.requiredFieldsError && <div style={ERRORSTYLE}>{this.state.requiredFieldsError}</div>}
                    <button type="submit" disabled={submitting}>
                      Submit
                    </button>
                    <button
                      type="button"
                      onClick={reset}
                      disabled={submitting || pristine}
                    >
                      Reset
                    </button>
                  </div>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )} />
            </div>
        </Styles>
      </div>
    );
  }
}
